import { Payload, useFetchMutation, usePost } from 'api/reactQuery/queryService';
import {
    IBinLotsFacade, ILookupResponse, IProductLookupSummaryDetailResponse, IProductLookupSummaryFacade, IValidatedResponse
} from 'api/swaggerTypes';
import { APIRoutes } from './constants';
import { IObjectified, objectify } from 'api/utils';

export type IBinLotsFacadeExtended = { DocumentId?: number; RequiredQuantity?: number; ProductId?: number } & IBinLotsFacade;
interface IUpdateProductWIPLotSerialPayload {
    DocumentId?: number;
    RequiredQuantity?: number;
    ProductId?: number;
    SuppliedQuantity?: number;
    KittingQuantity?: number;
    WarehouseEntity?: string;
}
interface IBatchInfo {
    BatchPage?: number;
    BatchSize?: number;
    Sort: string;
}

export const useUpdateProductWIPLotSerial = () =>
    usePost<Payload<{ BinLot: IBinLotsFacade }, IUpdateProductWIPLotSerialPayload>, IValidatedResponse>(
        APIRoutes.product.lotSerial.update,
        null,
        { inline: true }
    );

export const useFetchWarehouseProductLookup = () =>
    usePost<Payload<IBatchInfo & { Warehouse: string; CustomerId?: number; Type: string; SearchText: string; AlternateProductCheck: boolean }>, ILookupResponse>(
        APIRoutes.product.warehouseProductLookup.retrieve,
        null, null
    );

export type IObjectifiedWarehouseProductSummaryResponse = Omit<IProductLookupSummaryDetailResponse, 'ProductLookupSummary'> & {
    ProductLookupSummary: IObjectified<IProductLookupSummaryFacade>;
};

const WarehouseProductSummaryResponseParser = (response): Promise<IProductLookupSummaryDetailResponse> => {
    return {
        ...response,
        ProductLookupSummary: { inlineObject: objectify(response?.ProductLookupSummary), schema: response.ProductLookupSummary },

    };
};

export const useFetchWarehouseProductSummary = () =>
    useFetchMutation<Payload<{ ProductId: number; Warehouse: string }>, IObjectifiedWarehouseProductSummaryResponse>(
        APIRoutes.product.warehouseProductSummary.retrieve,
        null,
        { inline: true, responseParser: WarehouseProductSummaryResponseParser }
    );
